module.exports = __webpack_public_path__ + "static/media/shift_accessibility.68a17160.webp";